<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <!-- Internal Accounts -->
      <v-flex xs12 mb-3 class="flex-col">
        <breadcrumb :items="[{name: 'Home', url: '/dashboard'}]" :currentItem="i18n('Dashboard')" />
        <h1 class="max">{{i18n('Contas Internas FacilitaPay')}}</h1>
      </v-flex>
      <v-layout class="flex-col font-sans leading-normal tracking-normal">
        <div class="flex flex-wrap mt-3 overflow-hidden mx-2">
           <div v-for="balance in balances" :key="balance.id" :class="['metric-base', 'metric', 'balance', balance.klass]" @click="loadStatement(balance, true)">
             <div :class="['border-metric', balance.klass]">
              <div class="flex items-center">
                <v-icon class="rounded-full text-l">attach_money</v-icon>
                <div class="flex flex-col items-balance-left">
                  <div class="balance-title">{{balance.title}}</div>
                  <div class="balance-title" v-if="balance.flow_type">{{balance.flow_type}}</div>
                  <h3 class="balance-value">{{balance.value}}</h3>
                  <span v-if="balance.estimatedValue && balance.estimatedValue.length > 0">{{ i18n('Valor estimado') }}:</span>
                  <div v-for="value in balance.estimatedValue" :key="value">
                    <span>&asymp; {{ value }}</span>
                  </div>
                </div>
              </div>
             </div>
           </div>
        </div>
        <!-- Facilita Cash Out Internal Accounts -->
      <v-flex v-if="fx_cash_out_accounts.length > 0" xs12 mb-3 mt-3 class="flex-col">
        <h1 class="max">{{i18n('Contas de Taxas Operacionais')}}</h1>
      </v-flex>

        <div class="flex mobile-auto-wrap mt-3 overflow-hidden mx-2">
           <div v-for="balance in fx_cash_out_accounts" :key="balance.id" :class="['metric-base', 'metric', 'balance', balance.klass]" @click="loadStatement(balance, true)">
             <div :class="['border-metric', balance.klass]">
              <div class="flex items-center">
                <v-icon class="rounded-full text-l">paid</v-icon>
                <div class="flex flex-col items-balance-left">
                  <div class="balance-title">{{`${balance.currency} / ${balance.small_id}`}}</div>
                  <div class="balance-title">{{`CASH OUT`}}</div>
                  <h3 class="balance-value">{{balance.value}}</h3>
                  <span v-if="balance.estimatedValue && balance.estimatedValue.length > 0">{{ i18n('Valor estimado') }}:</span>
                  <div v-for="value in balance.estimatedValue" :key="value">
                    <span>&asymp; {{ value }}</span>
                  </div>
                </div>
              </div>
             </div>
           </div>
        </div>
        <!-- Graph -->
        <div class="w-full mb-5">
          <div v-if="false"
            class="bg-white border-transparent rounded-lg shadow-lg">
            <h5 class="font-paralucent p-10 text-3xl font-bold">{{i18n('Últimas transações')}}</h5>
            <div class="p-5">
              <div class="grid justify-items-end px-3">
                <div class="flex flex-row justify-items-end mb">
                  <span class="cursor-pointer font-paralucent py-2 px-3 mx-2 rounded-lg bg-gray-300" :class="{'bg-green': (0 == periodIndex)}" @click="periodIndex = 0">1 day</span>
                  <span class="cursor-pointer font-paralucent py-2 px-3 mx-2 rounded-lg bg-gray-300" :class="{'bg-green': (1 == periodIndex)}" @click="periodIndex = 1">7 days</span>
                  <span class="cursor-pointer font-paralucent py-2 px-3 mx-2 rounded-lg bg-gray-300" :class="{'bg-green': (2 == periodIndex)}" @click="periodIndex = 2">14 days</span>
                  <span class="cursor-pointer font-paralucent py-2 px-3 mx-2 rounded-lg bg-gray-300" :class="{'bg-green': (3 == periodIndex)}" @click="periodIndex = 3">30 days</span>
                </div>
              </div>
              <div class="max-w-full sm:max-w-md md:max-w-full xl:max-w-full">
                <transactions-chart :chart-data="transactionCollection" :height="150" :options="chartOptions"/>
              </div>
            </div>
          </div>
        </div>
        <div class="statement" id="table-statement">
          <div class="transactions-filter search-filter">
            <div class="search-filter-item">
              <v-flex class="date-filter" px-2>
                <DefaultFilterDate ref="filterStartDate" kind="date" @reload="this.reloadStartDate" label="Data inicial" />
              </v-flex>
              <v-flex class="date-filter">
                <DefaultFilterDate ref="filterEndDate" kind="date" @reload="this.reloadEndDate" label="Data final" />
              </v-flex>
              <v-btn class="btn-filter" color="#27DABC" depressed dark @click="loadStatement(statementBalance, true)">
                Filter
              </v-btn>
              <v-btn class="reload-filter" flat icon color="white" @click="resetFilter(statementBalance)">
                <ion-icon name="reload-outline" size="large"></ion-icon>
              </v-btn>
            </div>
          </div>
          <v-flex class="title-statement" v-if="downloadEnabled">
            <h4 class="max pl-3">{{i18n('Últimas transações')}} {{accountInfo}}</h4>
            <div>
              <span @click="downloadCsv()" class="rounded-chip mr-3">{{i18n('Baixar %s').replace('%s', 'CSV')}}</span>
              <span @click="downloadPdf()" class="rounded-chip mr-3">{{i18n('Baixar %s').replace('%s', 'PDF')}}</span>
            </div>
          </v-flex>

          <!-- Default Table -->
          <DefaultDataTable v-if="statementType == 'default'"
            :headers="headers"
            :items="recordStatement"
            :loading="loading"
            :no-data-text="i18n('Nenhuma transação registrada')">

            <template v-slot:items="props">
              <tr @click.stop="loadTransaction(props.item, props.index)">
                <td class="text-xs-left">
                  <span>{{ insertedDate(props.item) }}</span> <span class="font-weight-light">{{ insertedTime(props.item) }}</span>
                </td>
                <td class="text-xs-left">
                  <span>{{ props.item.social_name }}</span>
                  <br />
                  <span class="font-weight-light">{{ props.item.document_type.toUpperCase()}} {{ mask(props.item.document_type, props.item.document_number) }}</span>
                </td>
                <td class="text-xs-left">{{ props.item.kind }}</td>
                <td class="text-xs-center">{{ props.item.currency }}/{{ props.item.exchange_currency }}</td>
                <td class="text-xs-center">{{ exchangeRate(props.item) }}</td>
                <td class="text-xs-right">
                  <span>{{ statementValue(props.item) }}</span>
                  <br />
                  <span class="exchange-value" v-if="hasExchangeValue(props.item)">{{ statementExchangedValue(props.item) }}</span>
                </td>
              </tr>
            </template>
          </DefaultDataTable>

          <!-- Facilita Cash Out Table -->
          <DefaultDataTable v-if="statementType == 'facilita_cash_out'"
            :headers="headers"
            :items="recordStatement"
            :loading="loading"
            :no-data-text="i18n('Nenhuma transação registrada')">

            <template v-slot:items="props">
              <tr @click.stop="loadTransaction(props.item, props.index)">
                <!-- Date Column -->
                <td class="text-xs-left">
                  <span>{{ insertedDate(props.item) }}</span> <span class="font-weight-light">{{ insertedTime(props.item) }}</span>
                </td>
                <!-- Description Column -->
                <td class="text-xs-left">
                  {{ `${props.item.kind} ${i18n('De')}` }}
                  {{ `ID ${props.item.kind == 'FEE' ? getFeeTypeName(props.item.description) : props.item.social_name}` }}
                </td>
                <!-- Empty 1 -->
                <td></td>
                <!-- Transaction/Wire ID Column -->
                <td class="text-xs-left">
                  {{ `ID ${props.item.kind == 'FEE' ? props.item.object_id : props.item.id}` }}
                </td>
                <!-- Empty 2 -->
                <td></td>
                <td class="text-xs-right">
                  <span>{{ statementValue(props.item) }}</span>
                  <br />
                  <span class="exchange-value" v-if="hasExchangeValue(props.item)">{{ statementExchangedValue(props.item) }}</span>
                </td>
              </tr>
            </template>

          </DefaultDataTable>
        </div>
        <v-layout row wrap my-5>
          <v-flex xs6 pr-2>
            <v-btn class="btn-style ma-0 mr-2" block dark @click="loadPreviousPageRecords" v-show="hasPreviousPage"><v-icon left dark>skip_previous</v-icon> {{i18n('Mais Recentes')}}</v-btn>
          </v-flex>
          <v-flex xs6 pl-2>
            <v-btn class="btn-style--secondary ma-0 mr-2" block dark @click="loadNextPageRecords" v-show="hasNextPage">{{i18n('Mais Antigas')}} <v-icon right dark>skip_next</v-icon></v-btn>
          </v-flex>
        </v-layout>
        <details-dialog :addBtn="false" :record="selectedTransaction" :dialog="dialog" @closeDialog="closeDialog"/>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import CustomerScheduledBankTransactionDetailsDialog from "./CustomerScheduledBankTransactionDetailsDialog"
import DefaultDataTable from "./components/DefaultDataTable"
import DefaultFilterDate from "./components/filters/DefaultFilterDate"
import Title from "./components/Title"
import Breadcrumb from "./components/Breadcrumb"
import TransactionsChart from "./components/VueChart"
import statement from "./shared/Statement"
import utils from "./shared/Utils"
import { BankAccountsApi } from '@/shared/BankAccountsApi'

export default {
  name: 'Dashboard',
  components: {
    layout: LeftBarLayout,
    'page-title': Title,
    'breadcrumb': Breadcrumb,
    'transactions-chart': TransactionsChart,
    'details-dialog': CustomerScheduledBankTransactionDetailsDialog,
    DefaultDataTable,
    DefaultFilterDate
  },
  data(vm) {
    return {
      balances: [],
      fx_cash_out_accounts: [],
      taxes: {},
      last_id: null,
      dialog: false,
      loaded: false,
      reload: false,
      loading: false,
      periodIndex: 2,
      previous_ids: [],
      showError: false,
      recordStatement: [],
      statementType: "default",
      filterEndDate: null,
      filterStartDate: null,
      waitingForApproval: 0,
      selectedTransaction: {},
      exchangeRequestInterval: null,
      statementBalance: false,
      statementBalances: [],
      transactionCollection: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        animation: {
          easing: 'easeInOutQuad',
          duration: 900
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: 'rgba(200, 200, 200, 0.05)',
              lineWidth: 1
            }
          }],
          yAxes: [{
            gridLines: {
              color: 'rgba(200, 200, 200, 0.08)',
              lineWidth: 1
            }
          }]
        },
        elements: {
          line: {
            tension: 0.4
          }
        },
        legend: {
          display: true
        },
        point: {
          backgroundColor: 'white',
        },
        tooltips: {
          displayColors: false,
          titleFontFamily: 'Paralucent',
          backgroundColor: 'rgba(0,0,0,0.7)',
          titleFontColor: '#27DABC',
          titleFontSize: 15,
          bodyFontColor: 'white',
          bodyFontSize: 14,
          caretSize: 5,
          cornerRadius: 2,
          xPadding: 18,
          yPadding: 18
        }
      },
      headers: [
        { text: vm.i18n('Data'), value: 'inserted_at', align: 'left', sortable: false},
        { text: vm.i18n('Nome/Documento'), value: 'name', align: 'left', sortable: false },
        { text: vm.i18n('Tipo'), value: 'kind', align: 'left', sortable: false },
        { text: vm.i18n('Operação'), value: 'operation', align: 'center', sortable: false },
        { text: vm.i18n('Taxa de câmbio'), value: 'exchange_rate', align: 'center', sortable: false },
        { text: vm.i18n('Valor'), value: 'value', align: 'right', sortable: false }
      ],
      page_limit: 500
    }
  },
  computed: {
    downloadEnabled() {
      return this.recordStatement.length > 0
    },
    accountInfo() {
      if (!this.statementBalance) { return '' }

      if (this.statementBalance.flow_type == null) {
        return `${this.i18n('para conta interna')} ${this.statementBalance.currency}/${this.statementBalance.nickname != null ? this.statementBalance.nickname: this.statementBalance.small_id.toUpperCase()}`
      }

      return `${this.i18n('para conta interna')} ${this.statementBalance.currency}/${this.statementBalance.flow_type.toUpperCase()}/${this.statementBalance.nickname != null ? this.statementBalance.nickname: this.statementBalance.small_id.toUpperCase()}`
    },
    hasPreviousPage() {
      return this.previous_ids.length > 0
    },
    hasNextPage() {
      return this.recordStatement.length == this.page_limit
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
    this.$root.store.getCompany((company)=>{
      if (company) {
        this.company = company
      }
    }, (error)=>{
    })
    const isAdmin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'
    if (isAdmin) {
      this.$router.push('/admin/exchange')
    } else {
      this.getCompanyExchangeRates()
      this.loadBankAccounts();
    }

    this.$root.$on('reload-transactions', () => {
      this.loadBankAccounts()
    })
  },
  created() {
    this.exchangeRequestInterval = setInterval(() => {
      this.getCompanyExchangeRates()
    }, 60000);
  },
  destroyed() {
    clearInterval(this.exchangeRequestInterval)
  },
  methods: {
    getFeeTypeName(fee_type) {
      if (fee_type == "WIRE")
        return this.i18n('Transferência Internacional')
      else
        return fee_type
    },
    getHeaders(flow_type) {
      if (flow_type == "facilita_cash_out") {
        this.headers = [
          { text: this.i18n('Data'), value: 'inserted_at', align: 'left', sortable: false},
          { text: this.i18n('Descrição'), value: 'description', align: 'left', sortable: false },
          { text: this.i18n(''), value: 'empty1', align: 'left', sortable: false },
          { text: this.i18n('ID Transação/Transferência'), value: 'object_id', align: 'left', sortable: false },
          { text: this.i18n(''), value: 'empty2', align: 'left', sortable: false },
          { text: this.i18n('Valor'), value: 'value', align: 'right', sortable: false }
        ]
      } else {
        this.headers = [
          { text: this.i18n('Data'), value: 'inserted_at', align: 'left', sortable: false},
          { text: this.i18n('Nome/Documento'), value: 'name', align: 'left', sortable: false },
          { text: this.i18n('Tipo'), value: 'kind', align: 'left', sortable: false },
          { text: this.i18n('Operação'), value: 'operation', align: 'center', sortable: false },
          { text: this.i18n('Taxa de câmbio'), value: 'exchange_rate', align: 'center', sortable: false },
          { text: this.i18n('Valor'), value: 'value', align: 'right', sortable: false }
        ]
      }
    },
    reloadStartDate(filter_date) {
      this.filterStartDate = filter_date
    },
    reloadEndDate(filter_date) {
      this.filterEndDate = filter_date
    },
    resetFilter() {
      this.filterEndDate = null
      this.filterStartDate = null
      this.$refs.filterEndDate.filterDate = null
      this.$refs.filterStartDate.filterDate = null
      this.reloadStatement()
    },
    async loadNextPageRecords() {
      if (this.hasNextPage) {
        const balanceValue = await this.getBalance(this.statementBalance.id, this.filterEndDate)
        const builtStatement = statement.buildStatementRowsWithBalance(
          this.recordStatement,
          this.statementBalance,
          balanceValue,
          this.hasPreviousPage,
          this.hasNextPage
        );

        this.statementBalances.push(builtStatement.balance)
        this.previous_ids = this.previous_ids.concat(this.last_id)
        this.last_id = this.recordStatement[this.recordStatement.length - 1]['id']
        this.loadStatement(this.statementBalance)
        this.moveScrollUp()
      }
    },
    async getBalance(bank_account_id, filterEndDate) {
      let balance_to_send;

      if (filterEndDate) {
        try {
          const token = this.$cookies.get('api_token')
          const url = this.$root.urls.customer__bank_accounts_balance.replace('ID', bank_account_id)
          const formattedDate = new Date(filterEndDate + 'T23:59:59.999Z').toISOString()

          const response = await this.$http.get(url, {
            params: { end_date: formattedDate },
            headers: { Authorization: `Bearer ${token}` }
          })

          if (response.body.data) {
            balance_to_send = !this.hasPreviousPage
              ? response.body.data.balance
              : this.statementBalances[this.statementBalances.length - 1]

            return balance_to_send
          } else {
            this.feedbackMsg = 'No records found for the selected range.'
            return 0
          }
        } catch (error) {
          console.error('Error fetching balance.:', error)
          if (error.status === 401) {
            this.feedbackMsg = 'Unauthorized. Please log in.'
          } else {
            this.feedbackMsg = 'An error occurred. Please contact IT.'
          }
          return 0
        }
      } else {
        balance_to_send = !this.hasPreviousPage
          ? this.statementBalance.value
          : this.statementBalances[this.statementBalances.length - 1]

        return balance_to_send
      }
    },
    loadPreviousPageRecords() {
      if (this.hasPreviousPage) {
        this.statementBalances.pop()
        this.last_id = this.previous_ids.pop()
        this.loadStatement(this.statementBalance)
        this.moveScrollUp()
      }
    },
    moveScrollUp() {
      setTimeout(function(){
        this.$nextTick(function(){
          this.$vuetify.goTo('#table-statement', {duration: 800, offset: 100, easing: 'easeInOutCubic'})
        })
      }.bind(this), 100)
    },
    i18n(str) {
      return this.$root.l(str)
    },
    localeCurrency(value, currency) {
      return this.$root.localeCurrency(value, currency)
    },
    fillData() {
      const response = {
        data: {
          labels: ['January', 'February', 'March'],

          sets: [
            {
              label: 'Total Balance (BRL)',
              backgroundColor: 'rgb(90, 80, 20, 0.16)',
              borderColor: 'rgb(90, 80, 20, 0.2 )',
              data:[
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt()
              ]
            },
            {
              label: 'Total Balance (USD)',
              backgroundColor: 'rgb(124, 160, 192, 0.16)',
              borderColor:'rgb(124, 160, 192)',
              data:[
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt()
              ]
            },
            {
              label: 'Balance Sent (USD)',
              backgroundColor: 'rgb(255, 114, 110, 0.16)',
              borderColor:'rgb(255, 114, 110)',
              data:[
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt()
              ]
            },
              {
              label: 'Balance Received (USD)',
              backgroundColor: 'rgb(7, 169, 124, 0.16)',
              borderColor:'rgb(7, 169, 124)',
              data:[
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt(),
                this.getRandomInt()
              ]
            },
          ]
        }
      }

      const { data } = response
      const { labels, sets } = data

      this.transactionCollection.datasets = sets.map(item => {
        const defaultColor = '#2f5473'
        return {
          pointBackgroundColor: 'white',
          pointBorderColor: item.pointBorderColor || defaultColor,
          pointHitRadius: 7,
          pointRadius: 3,
          borderWidth: 2,
          fill: true,

          borderColor: item.borderColor || defaultColor,
          backgroundColor: item.backgroundColor || defaultColor,
          label: item.label,
          data: item.data
        }
      })

      this.transactionCollection.labels = labels
      this.loaded = true
    },
    getRandomInt() {
      return Math.floor(Math.random() * 46) + 5
    },
    klassFor(currency) {
      let result = ''
      switch(currency) {
        case 'BRL':
        case 'MXN':
        case 'COP':
        case 'CLP':
          result = 'b-golden'
          break
        case 'USD':
          result = 'b-green'
          break
        case 'EUR':
          result = 'b-blue'
          break
        default:
          result = 'b-red'
      }
      return result
    },
    getCompanyExchangeRates() {
      const successCallback = ({ status, body }) => {
        if (status === 200) {
          this.taxes = body.data;
        }
      };

      const errorCallback = (response) => {
        console.log(response);
      };

      const token = this.$cookies.get('api_token');
      const url = this.$root.urls.exchange_rates;

      this.$http.get(url, { headers: { Authorization: `Bearer ${token}` }})
        .then(successCallback)
        .catch(errorCallback)
    },
    loadBankAccounts() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.balances = response.body.data.filter(bank_account => { return !!bank_account.internal }).map( bank_account => {
            const id = bank_account.id
            const small_id = bank_account.id.split('-')[0]
            const nickname = bank_account.nickname
            const currency = bank_account.currency
            const flow_type = bank_account.flow_type
            const title = `${this.i18n('Saldo Total')} (${currency}/${nickname != null ? nickname: small_id})`
            const klass = this.klassFor(currency)
            const value = this.localeCurrency('0.00', currency)
            const company_social_name = bank_account.owner_company.social_name
            const branch_number = bank_account.branch_number
            const account_number = bank_account.account_number
            return {id, small_id, nickname, currency, title, klass, value, flow_type, company_social_name, account_number, branch_number}
          })
          if (this.balances.length > 0) {
            this.loadStatement(this.balances[0])
          }
          this.loadBalances()
        } else {
          this.balances = []
          console.log(response)
        }
      }

      let errorCallback = (response) => {
        this.balances = []
        console.log(response)
      }

      BankAccountsApi.onlyGet(this, this.$root.urls.bank_accounts, successCallback, errorCallback);
    },
    loadBalances() {
      let successCallbackFor = (context) => {
        return function(response) {
          if (response.body.data) {
            const index = context.balances.findIndex(el => el.id === context.id)
            let balance = context.balances[index]
            balance.value = context.localeCurrency(response.body.data.balance, balance.currency)
            balance.estimatedValue = this.estimatedValue(response.body.data.balance, balance.currency)
            context.balances.splice(index, 1, balance)
          } else {
            console.log(response)
          }
        }
      }

      let errorCallbackFor = (context) => {
        return function(response) {
          console.log(response)
        }
      }

      const token = this.$cookies.get('api_token')
      const balances = this.balances
      const localeCurrency = this.localeCurrency
      this.balances.forEach(balance => {
        const url = `${this.$root.urls.bank_accounts}${balance.id}/balance`
        const id = balance.id
        const context = {id, balances, localeCurrency}
        this.$http.get(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallbackFor(context), errorCallbackFor(context))
      })
      this.fx_cash_out_accounts = this.balances.filter(bank_account => bank_account.flow_type == "facilita_cash_out")
      this.balances = this.balances.filter(bank_account => bank_account.flow_type != "facilita_cash_out")
    },
    estimatedValue(balance, currency) {
      const internalBalancesCurrency = [... new Set(this.balances.map(b => b.currency))];

      return internalBalancesCurrency.reduce((result, internalCurrency) => {
        const exchangeKey = `${currency.toLowerCase()}${internalCurrency.toLowerCase()}`;
        const exchangeRate = this.taxes[exchangeKey];
        if (exchangeRate) {
          const estimatedValue = this.$root.isLocalCurrency(currency) ? balance / exchangeRate : balance * exchangeRate;
          result.push(this.localeCurrency(estimatedValue, internalCurrency));
        }

        return result;
      }, []);
    },
    insertedDate(record) {
      return utils.dbDateTimeToHuman(record.inserted_at).split(' ')[0]
    },
    insertedTime(record) {
      return utils.dbDateTimeToHuman(record.inserted_at).split(' ')[1]
    },
    mask(format, value) {
      return utils.mask(format, value)
    },
    exchangeRate(item) {
      return statement.exchangeRate(item)
    },
    statementValue(item) {
      return statement.statementValue(item)
    },
    hasExchangeValue(item) {
      return statement.hasExchangeValue(item)
    },
    statementExchangedValue(item) {
      return statement.statementExchangedValue(item)
    },
    closeDialog() {
      this.dialog = false
    },
    reloadStatement() {
      if (this.loading) {
        this.reload = true
      } else {
        this.reload = false
        this.statementBalances = []
        this.last_id = null
        this.previous_ids = []
        this.loadStatement(this.statementBalance)
      }
    },
    loadStatement(balance, clear = false) {
      if (this.loading) return

      if (clear) {
        this.statementBalances = []
        this.last_id = null
        this.previous_ids = []
      }

      this.statementBalance = balance

      let successCallback = (response) => {
        if (response.body.data) {
          this.getHeaders(balance.flow_type)
          this.statementType = balance.flow_type == "facilita_cash_out" ? "facilita_cash_out" : "default"

          this.recordStatement = response.body.data
          if (this.recordStatement.length === 0) {
            this.loaded = 'empty'
          } else {
            this.loaded = 'ok'
          }
        } else {
          this.loaded = 'error'
        }

        this.loading = false
        if (this.reload) {
          this.reloadStatement()
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.loaded = 'not_authorized'
        } else {
          this.loaded = 'error'
        }

        this.loading = false
        if (this.reload) {
          this.reloadStatement()
        }
      }

      const token = this.$cookies.get('api_token')
      this.loading = true
      let params = { per_page: this.page_limit }

      if (this.last_id)  {
        params.last_id = this.last_id
      }

      if (this.filterStartDate) { params.from = utils.filterDateFrom(this.filterStartDate, false).toISOString() }
      if (this.filterEndDate) { params.to = utils.filterDateTo(this.filterEndDate, false).toISOString() }

      const url = this.$root.urls.customer__scheduled_transaction_statement.replace('ID', balance.id)
      this.$http.get(url, { params: params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    loadTransaction(item) {
      let successCallbackDefault = (response) => {
        let loadedValue = ""
        let data = response.body.data

        if (data && Object.keys(data).length === 0) {
          loadedValue = "empty"
        }
        else if (data && data.subject_id !== this.company.id) {
          loadedValue = "ok"
          this.loadSubject(item.document_type, data.subject_id)
        }
        else if (data && data.subject_id === this.company.id) {
          loadedValue = "ok"
          data.subject = this.company
          this.dialog = true
        }
        else {
          loadedValue = "error"
        }

        this.loaded = loadedValue
        this.selectedTransaction = data
      }

      let successCallbackTransaction = (response) => {
        let loadedValue = ""
        let data = response.body.data

        if (data && Object.keys(data).length === 0) {
          loadedValue = "empty"
        }
        else if (data && data.subject_id !== this.company.id) {
          loadedValue = "ok"
          this.loadSubject(data.source_document_type, data.subject_id)
        }
        else if (data && data.subject_id === this.company.id) {
          loadedValue = "ok"
          data.subject = this.company
          this.dialog = true
        }
        else {
          loadedValue = "error"
        }

        this.loaded = loadedValue
        this.selectedTransaction = data
        this.selectedTransaction.record_type = "internal_transaction"
      }

      let successCallbackWire = (response) => {
        let loadedValue = ""
        let data = response.body.data

        if (data && Object.keys(data).length === 0) {
          loadedValue = "empty"
        }
        else if (data && Object.keys(data).length > 0) {
          loadedValue = "ok"
          this.dialog = true
        }
        else {
          loadedValue = "error"
        }

        this.loaded = loadedValue
        this.selectedTransaction = data
        this.selectedTransaction.record_type = "internal_wire"
        this.selectedTransaction.status = "wired"
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.loaded = 'not_authorized'
        } else {
          this.loaded = 'error'
        }
      }
      const token = this.$cookies.get('api_token')

      // This branches will call the correct endpoint for internal transactions (liabilities).
      if (item.object_type == "company_wire") {
        let url = `${this.$root.urls.customer__receipt}${item.object_id}`
        this.$http.get(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallbackWire, errorCallback)
      }
      else if (item.object_type == "scheduled_bank_transaction") {
        let url = this.$root.urls.customer__scheduled_bank_transactions_id.replace('ID', item.object_id)
        this.$http.get(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallbackTransaction, errorCallback)
      }
      else {
        let url = this.$root.urls.customer__scheduled_bank_transactions_id.replace('ID', item.id)
        this.$http.get(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallbackDefault, errorCallback)
      }
    },
    loadSubject(document_type, id){
      let successCallback = (response) => {
        if (response.body.data) {
          if (response.body.data.length === 0) {
            this.loaded = 'empty'
          } else {
            this.selectedTransaction.subject = response.body.data
            this.dialog = true
            this.loaded = 'ok'
          }
        } else {
          this.loaded = 'error'
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.loaded = 'not_authorized'
        } else {
          this.loaded = 'error'
        }
      }

      let token = this.$cookies.get('api_token')
      let url = ""
      if (document_type == "cnpj") url = this.$root.urls.customer__companies__id.replace('ID', id)
      else url = this.$root.urls.customer__people__id.replace('ID', id)
      this.$http.get(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    async downloadCsv() {
      let recordStatementCVS = []
      if (this.hasNextPage || this.hasPreviousPage) {

        let successCallback = async (response) => {
          if (response.body.data) {
            recordStatementCVS.push(...response.body.data);

            if (response.body.data.length == this.page_limit) {
              const params = this.downloadCsvParams(false, recordStatementCVS)
              this.$http.get(url, { params: params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
            } else {
              let initialBalance
              if (this.filterEndDate) {
                initialBalance = await this.calculateInitialBalance(this.statementBalance.id, this.filterEndDate);
              }
              statement.exportAndDownloadCsv(recordStatementCVS, this.statementBalance, initialBalance)
            }
          }
        }

        let errorCallback = (response) => {
          console.log(response)
        }

        const token = this.$cookies.get('api_token')
        const url = this.$root.urls.customer__scheduled_transaction_statement.replace('ID', this.statementBalance.id)
        let params = this.downloadCsvParams(true, null)

        this.$http.get(url, { params: params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      } else {
        let initialBalance
        if (this.filterEndDate) {
          initialBalance = await this.calculateInitialBalance(this.statementBalance.id, this.filterEndDate);
        }
        statement.exportAndDownloadCsv(this.recordStatement, this.statementBalance, initialBalance)
      }
    },
    downloadCsvParams(isFirstCall, recordStatementCVS) {
      let params = { per_page: this.page_limit }

      // When we have more than one page, we will call this function more than one time,
      // from the second time onwards, we need to get the last id from the list we have.
      if (!isFirstCall) {
        params.last_id = recordStatementCVS[recordStatementCVS.length - 1]['id']
      }

      if (this.filterStartDate) { params.from = utils.filterDateFrom(this.filterStartDate, false).toISOString() }
      if (this.filterEndDate) { params.to = utils.filterDateTo(this.filterEndDate, false).toISOString() }

      return params
    },
    async downloadPdf() {
      const balanceValue = await this.getBalance(this.statementBalance.id, this.filterEndDate)

      statement.exportAndDownloadPdf(
        this.recordStatement,
        this.statementBalance,
        balanceValue,
        this.filterStartDate,
        this.filterEndDate,
        this.hasPreviousPage,
        this.hasNextPage
      )
    },
    async calculateInitialBalance(statement_balance_id, filterEndDate) {
      const token = this.$cookies.get('api_token');
      const url = this.$root.urls.customer__bank_accounts_balance.replace('ID', statement_balance_id);
      const formattedDate = new Date(filterEndDate + 'T23:59:59.999Z').toISOString()
      const params = { end_date: formattedDate };

      try {
        const response = await this.$http.get(url, {
          params,
          headers: { Authorization: `Bearer ${token}` },
        });

        return response.body.data.balance;
      } catch (error) {
        console.error(error);
        return 0;
      }
    }

  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style scoped>
  .search-filter  {
    display: flex;
    justify-content: flex-end;
    padding-right: 1%;
  }
  .search-filter-item {
    display: flex;
    align-items: center;
  }
  .date-filter {
    padding-top: 30px!important
  }
  .btn-download {
    padding-top: 1.5%;
  }
  .btn-filter {
    margin: 0% 10px;
    border-radius: 4px;
    height: 55px;
  }
  .reload-filter {
    margin: 0%;
    border-radius: 4px;
    height: 55px;
    width: 56px;
    background-color: #BCC1D1;
  }
  .visible-mark {
    width: 100px;
    height: 2px;
  }
  .v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before {
    background-color: white!important;
  }
  .cursor-pointer{
    cursor: pointer;
  }
  .flex{
    display: flex;
  }
  .flex-1{
    flex: 1 1 0%;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-col {
    flex-direction: column;
  }
  .border-b-2{
    border-bottom-width: 2px;
  }
  .uppercase {
    text-transform:uppercase!important;
  }
  .green {
    color: #27DABC !important;
  }
  .bg-green {
    background-color: #27DABC !important;
    color:white;
  }
  .green-b-border {
    border-bottom-width: 2px;
    border-color: #27DABC;
  }
  .dashboard-layout {
    align-items: stretch;
  }
  .dashboard-layout .v-card__title {
    color: #092f4f;
  }
  i.v-icon {
    font-size: 38px !important;
    padding: 5px !important;
    color: purple;
  }
  .font-bold {
    font-weight: 700;
  }
  .font-paralucent {
    font-family: 'Paralucent';
  }
  .rounded-lg {
    border-radius: 0.5rem;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .flex-col{
    flex-direction: column;
  }
  .leading-normal {
    line-height: 1.5;
  }
  .mb-5 {
    margin-bottom:5px;
  }
  .mt-3 {
    margin-top:3px;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .bg-white {
    background-color: white;
  }
  .my-3 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .px-3 {
    padding-left: 0.75rem ;
    padding-right: 0.75rem;
  }
  .py-3 {
    padding-top: 0.75rem ;
    padding-bottom: 0.75rem;
  }
  .mr-3 {
    margin-right: 0.75rem;
  }
  .my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .mb {
    margin-bottom: 50px;
  }
  .w-full {
    width: 100%;
  }
  .rounded-md {
    border-radius: 0.375rem;
  }
  .rounded-lg {
    border: 0.5rem;
  }
  .rounded-full {
    border-radius: 9999px;
  }
  .shadow-lg {
    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 1px 2px 0 rgba(0,0,0,0.06);
  }
  .items-center {
    align-items: center;
  }
  .items-balance-left {
    margin-left: 1.75rem;
    align-items: left;
  }
  .max-w-full {
    max-width: 100%;
  }
  .max-w-xl {
    max-width: 36rem;
  }
  .grid {
    display: grid;
  }
  .border-transparent {
    border-color: transparent;
  }
  .font-paralucent {
    font-family: paralucent;
  }
  .p-10 {
    padding: 2.5rem;
  }
  .text-3xl {
    font-size: 1.875rem;
  }
  .font-bold {
    font-style: bold;
  }
  .p-5 {
    padding: 1.25rem;
  }
  .justify-items-end {
    justify-content: end;
  }
  .flex-row {
    flex-direction: row;
  }
  .statement  {
    padding: 1%;
    background-color: white;
    border-radius: 1rem;
    box-shadow: 3px 8px 8px #cccccc52;
  }
  .title-statement {
    align-items: center;
    justify-content: space-between;
  }
  .metric-base {
    cursor: pointer;
    background-color: white;
    padding: 1.75rem 0px 1.75rem 0px;
    margin: 0.75rem;
    width: 100%;
    overflow: hidden;
    border-radius: 1rem;
    box-shadow: 3px 8px 8px #cccccc52;
  }
  .mobile-auto-wrap {
    flex-wrap: wrap;
  }
  .border-metric {
    padding-left: 0.75rem;
    border-left: 3px;
    border-left-style: solid;
  }
  .balance-title {
    font-family: Paralucent;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    text-transform: uppercase;
    color: #BCC1D1;
  }
  .balance-value {
    font-family: Paralucent;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 29px;
    color: #44517B;
  }
  .exchange-value  {
    font-size: 11px;
    font-style: normal;
  }
  /* mobile (sm/md) */
  @media(max-width: 992px) {
    .mobile-auto-wrap {
      flex-wrap: wrap;
    }
    .metric{
      width: 100%;
    }
  }

  /* desktop (xl) */
  @media (min-width: 1200px){
    .mobile-auto-wrap {
      flex-wrap: nowrap;
    }
    .metric {
      width: 23%;
    }
  }

.line-chart {
  animation: fadeIn 600ms cubic-bezier(.57,.25,.65,1) 1 forwards;
  opacity: 0;
  max-width: 640px;
  width: 100%;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.b-golden { border-color: #908C63!important; }
.b-golden i.v-icon { color: #908C63!important; background-color: rgba(144, 140, 99, 0.2)!important; }
.b-blue { border-color: #7ca0c0!important; }
.b-blue i.v-icon { color: #7ca0c0!important; background-color: rgba(144, 140, 99, 0.2)!important; }
.b-red { border-color: #FF726E!important; }
.b-red i.v-icon { color: #FF726E!important; background-color: rgba(144, 140, 99, 0.2)!important; }
.b-green { border-color: #07A97C!important; }
.b-green i.v-icon { color: #07A97C!important; background-color: rgba(144, 140, 99, 0.2)!important; }
</style>



// WEBPACK FOOTER //
// src/Dashboard.vue